<template>
  <section class="user-detail-container">
    <base-header v-bind="headers"
      v-on:handleReset="handleHeaderReset"
    />
    <base-form
      v-bind="form"
      v-on:handleConfirm="handleConfirm"
    ></base-form>
    <form-dialog
    title="重置密码"
      ref="updateDialog"
      :loading="updateFormLoading"
      :form="updateForm"
      :rules="updateRules"
      :formItems="updateFormItems"
      :buttons="updateButtons"
      v-on:handleConfirm="handleConfirmUpdate"
    ></form-dialog>
  </section>
</template>
<script>
import user from './user'

export default {
  name: 'userCreate',
  mixins: [user],
  data () {
    var email = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        var params = {
          mail: value,
          id: this.form.form.id
        }
        this.$request.fetchSysMailUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error('邮箱已存在'))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    var phone = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        var params = {
          phone: value,
          id: this.form.form.id
        }
        this.$request.fetchSysPhoneUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error('手机号码已存在'))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    return {
      backUrl: '/memberManage/chiefEditor/index',
      headers: {
        buttons: [
          // {
          //   type: 'Reset',
          //   text: '重置密码',
          //   icon: 'zhongzhimima'
          //   // disabled: !this._checkPermission('/admin/users/psw', 'POST')
          // }
        ],
        title: '编辑用户',
        showAlertIcon: true,
        content: '任何用户不可禁用或启用自己；'
      },
      form: {
        api: 'fetchMemberManageEditorGet',
        params: {
          id: ''
        },
        form: {
          'id': '',
          'psw': '',
          'realname': '',
          'usePhone': '',
          'email': '',
          'enabled': true,
          'roleid': [],
          'gender': ''
        },
        formItems: [
          {
            prop: 'username',
            label: '用户名：',
            maxlength: 20,
            type: 'text'
          },
          {
            type: 'select',
            prop: 'roleid',
            label: '所属角色：',
            optionLabel: 'roleName',
            optionValue: 'id',
            placeholder: '请选择',
            options: []
          },
          {
            prop: 'realname',
            label: '真实姓名：',
            maxlength: 50,
            placeholder: '请输入您的真实姓名'
          },
          {
            type: 'radio',
            prop: 'gender',
            label: '性别：',
            options: [
              {
                label: '男',
                value: 1
              },
              {
                label: '女',
                value: 2
              }
            ]
          },
          {
            prop: 'usePhone',
            label: '手机号：',
            maxlength: 11
          },
          {
            prop: 'email',
            label: '电子邮箱：',
            maxlength: 30
          },
          {
            prop: 'enabled',
            type: 'switch',
            label: '用户状态：'
          }
        ],
        rules: {
          username: [
            this.$rules.required()
          ],
          email: [
            this.$rules.email(),
            this.$rules.required(),
            { validator: email, trigger: 'blur' }
          ],
          usePhone: [
            this.$rules.mobile(),
            { validator: phone, trigger: 'blur' }
          ],
          enabled: [
            this.$rules.required()
          ],
          roleid: [
            this.$rules.required()
          ]
        },
        submitBtns: [{
          text: '保存',
          subType: 'submit',
          notDisabled: true
        }]
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    // 发送请求事件
    handleHeaderReset (data, btn) {
      this.updateForm.username = this.form.form.username
      this.updateForm.id = this.form.form.id
      this.$refs.updateDialog.showDialog()
    },
    handleConfirm (data) {
      this.form.loading = true
      this.$request.fetchMemberManageEditorUpdate(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          setTimeout(() => {
            this.removeTab(this.$route.fullPath)
            this.$routerLink(this.backUrl, 'list')
          }, 500)
        }
        this.hideFormLoading()
      }).catch(this.hideFormLoading)
    },

    fetchFormCallBack (res) {
      if (res.code === 200) {
        let managerAble = res.data.managerAble
        if (!managerAble) {
          this.headers.buttons.forEach(v => {
            v.disabled = true
          })
          if (this.user.userName === res.data.username) {
            this.form.formItems.find(d => d.prop === 'roleid').disabled = true
            this.form.formItems.find(d => d.prop === 'enabled').disabled = true
          } else {
            this.form.submitBtns.forEach(v => {
              v.disabled = true
            })
          }
        } else {
          this.headers.buttons.forEach(v => {
            v.disabled = false
          })
          this.form.submitBtns.forEach(v => {
            v.disabled = false
          })
        }
        this.form.form = Object.assign({}, this.form.form, res.data)
        this.form.form.roleid = res.data.roleIds[0]
        this.form.form.gender = res.data.userExt.gender || ''
        this.form.form.realname = res.data.userExt.realname || ''
        this.form.form.usePhone = res.data.telephone
        this.form.formItems.find(d => d.prop === 'enabled').disabled = !res.data.deleteAble
        this.form.formItems.find(d => d.prop === 'roleid').disabled = !res.data.notCurrUser
        this.headers.buttons.find(d => d.type === 'Reset').disabled = !res.data.deleteAble
        this.form.submitBtns.find(d => d.subType === 'submit').disabled = !res.data.managerAble
      }
    },
    getUserData () {
      const { id } = this.$route.query
      if (id && id !== this.form.params.id) {
        this.form.params.id = id
        this.fetchFormApi()
      }
    },
    fetchMemberManageRolesList () {
      this.$request.fetchMemberManageRolesList({ filter: true }).then(res => {
        if (res.code === 200) {
          this.form.formItems.find(d => d.prop === 'roleid').options = res.data
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getUserData()
    })
    this.fetchMemberManageRolesList()
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      if (newRoute.name === 'userCreate') {
        this.getUserData()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box-items{
    padding: 0 9px;
  }
</style>
